// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__P-pw3","others-header__buttons":"Header_others-header__buttons__lWRm4"};